import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GuestRegisterAddAccountUseCase extends BaseUseCase {
    constructor(loginFLowRepo) {
        super();
        this.loginFLowRepo = loginFLowRepo;
    }
    async fetchResult(req) {
        return await this.loginFLowRepo.guestRegisterAddAccount(req);
    }
}
export default GuestRegisterAddAccountUseCase;
